module.exports = "<div *ngIf=\"!isError\" class=\"container\">\r\n  <div class=\"application-bar\">\r\n    <div >\r\n      <ul nav-tab class=\"nav nav-tabs\">\r\n        <li routerLinkActive=\"active\">\r\n            <a routerLink=\"/settings/user\">User</a>\r\n        </li>\r\n        <li routerLinkActive=\"active\">\r\n          <a routerLink=\"/settings/client\">Client</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n  <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/settings/settings.component.html
// module id = ../../../../../src/app/components/settings/settings.component.html
// module chunks = main